import { PlatformService } from "src/app/system/utility/platform.service";
import { BankTemplate } from "../bank-template/bank-template-bean";
import { ScreenType } from "../responsive-design/responsive-design.service";
import { PABankTemplateMenuBuilder } from "./pa-bank-template-menu-builder";
import { MenuType } from "./pa-menu-meta";
import { PermittedActivityService } from "./permitted-activity.service";

/* 
Menu Hierarchy

Before Adding the Section/Sector Layer:

-- Desktop Left Menu
-- Desktop Top Menu
-- Desktop Small Screen (Tablet) Hidden Left Menu
-- Desktop XS Screen Left Menu
-- Desktop Small Screen (Tablet) Hidden Top Menu
1. Menu
2. Group
3. Activity

Mobile Menu
1. Menu
2. Sector
3. Group (not expandable)

------------------------------------------------------

To make it consistent, there will be a new layer "section/sector" to all desktop/tablet menus. Even if those menus does not have nested group
In this way, the GetDesktopMenuSetting method can be reused. No need to add new methods for each desktop menus

------------------------------------------------------

After adding the Section/Sector layer:
-- Desktop Left Menu
-- Desktop Top Menu
-- Desktop Small Screen (Tablet) Hidden Left Menu
-- Desktop XS Screen Left Menu
-- Desktop Small Screen (Tablet) Hidden Top Menu
1. Menu
2. Section
3. Group
4. Activity

Mobile Menu
1. Menu
2. Sector
3. Group (not expandable)

------------------------------------------------------

Given the Menu data, there will be 4 menu types
1. Mobile Menu
2. Desktop XS Screen Left Menu (To be confirmed)
3. General Desktop (including Corp)
  -- Desktop Left Menu
  -- Desktop Small Screen (Tablet) Hidden Left Menu
  -- Desktop Small Screen (Tablet) Hidden Top Menu
4. Desktop Top Menu

*/

export abstract class PAMenuDisplayCondition {

	protected template: string = BankTemplate.STANDARD;
	PlatformService: any = PlatformService;

	constructor(
		protected menuType: MenuType,
		protected screenType: ScreenType,
		protected srvPermitted: PermittedActivityService) {
		this.template = this.srvPermitted.externalSettings.templates;
	}
	abstract isSatisfied(): boolean;
	abstract buildMenu(): any;

	protected isMobileView(): boolean {
		if (this.PlatformService.isMobile()) return false;
		return this.screenType === ScreenType.TypeXS;
	}

	protected isMobileApp(): boolean {
		return this.PlatformService.isMobile();
	}

	protected isDesktopTop(): boolean {
		return this.PlatformService.isBrowser() && this.menuType === MenuType.TOP && this.screenType === ScreenType.TypeXL;
	}

	protected isDesktop(): boolean {
		if (this.isMobileApp() || this.isMobileView() || this.isDesktopTop()) return false;
		return true;
	}
}

/* 
-- Desktop Left Menu
-- Desktop Small Screen (Tablet) Hidden Left Menu
-- Desktop Small Screen (Tablet) Hidden Top Menu
*/
export class Condition_PAMenuDesktop extends PAMenuDisplayCondition {
	isSatisfied(): boolean {
		return this.isDesktop();
	}
	buildMenu() {
		this.srvPermitted.menuDesktop$.next(PABankTemplateMenuBuilder.buildBankTemplateMenuDesktop(this.template));
	}
}

/* Desktop Top Menu */
export class Condition_PAMenuDesktopTop extends PAMenuDisplayCondition {
	isSatisfied(): boolean {
		return this.isDesktopTop();
	}
	buildMenu() {
		this.srvPermitted.menuDesktopTop$.next(PABankTemplateMenuBuilder.buildBankTemplateMenuDesktopTop(this.template));
	}
}

/* Mobile View Left Menu */
export class Condition_PAMenuMobileView extends PAMenuDisplayCondition {
	isSatisfied(): boolean {
		return this.isMobileView();
	}
	buildMenu() {
		this.srvPermitted.menuMobileView$.next(PABankTemplateMenuBuilder.buildBankTemplateMenuMobileView(this.template));
	}
}

/* Mobile App Left Menu */
export class Condition_PAMenuMobileApp extends PAMenuDisplayCondition {
	isSatisfied(): boolean {
		return this.isMobileApp();
	}
	buildMenu() {
		this.srvPermitted.menuMobileApp$.next(PABankTemplateMenuBuilder.buildBankTemplateMenuMobileApp(this.template));
	}
}
